import { useTranslation } from 'react-i18next'
import { ChannelType, Subscription } from '../../types'
import Button from '../../ui/Button'
import { DataTable } from '../../ui/DataTable'
import Heading from '../../ui/Heading'
import { CheckIcon, PlusIcon } from '../../ui/icons'
import Tag from '../../ui/Tag'
import { internalTopicChannels, TopicChannel } from './topics'
import './Subscriptions.css'

interface TopicChannelSectionProps extends TopicChannel {
    isLoading?: boolean
    onAdd: (channel: ChannelType) => void
    onEdit: (subscription: Subscription) => void
}

export default function TopicChannelSection({ channel, master, topics, isLoading = false, onAdd, onEdit }: TopicChannelSectionProps) {
    const { t } = useTranslation()
    const label = t(channel).toLowerCase()
    const isInternal = internalTopicChannels.includes(channel)

    return (
        <div className="topic-channel-section">
            <Heading
                size="h3"
                title={t(channel)}
                actions={
                    <>
                        {master && (
                            <Button
                                variant="secondary"
                                size="small"
                                onClick={() => onEdit(master)}
                            >{t('edit')}</Button>
                        )}
                        <Button
                            variant="primary"
                            size="small"
                            icon={<PlusIcon />}
                            onClick={() => onAdd(channel)}
                        >{t('add_channel_topic', { channel: label })}</Button>
                    </>
                }
            >
                {master && (
                    <div className="topic-channel-meta">
                        {isInternal
                            ? <Tag variant="plain" size="tiny">{t('internal_channel_hidden')}</Tag>
                            : <Tag variant="success" size="tiny">{t('in_preference_center')}</Tag>}
                        {channel === 'text' && <Tag variant="info" size="tiny">{t('text_reenable_start_only')}</Tag>}
                    </div>
                )}
            </Heading>
            <DataTable
                columns={[
                    {
                        key: 'name',
                        title: t('name'),
                    },
                    {
                        key: 'is_public',
                        title: t('public'),
                        cell: ({ item }) => item.is_public ? <CheckIcon /> : undefined,
                    },
                    {
                        key: 'is_opt_in',
                        title: t('opt_in'),
                        cell: ({ item }) => item.is_opt_in ? <CheckIcon /> : undefined,
                    },
                    {
                        key: 'id',
                        title: t('id'),
                        align: 'end',
                    },
                ]}
                items={topics}
                itemKey={({ item }) => item.id}
                isLoading={isLoading}
                emptyMessage={t('no_channel_topics', { channel: label })}
                onSelectRow={onEdit}
            />
        </div>
    )
}
